import { useState, useEffect } from "react";
import { useReloadOnRouteEnter } from "../hooks/useReloadOnRouteEnter";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import { textIncludesAny } from "../utils/searchText";

const FAMILIA_COLOR = {
  residencial: "bg-blue-100 text-blue-700",
  comercial: "bg-orange-100 text-orange-700",
  industrial: "bg-gray-100 text-gray-700",
  terrenos: "bg-green-100 text-green-700",
  otros: "bg-purple-100 text-purple-700"
};

const ESTADO_COLOR = {
  activa: "bg-green-100 text-green-700",
  pausada: "bg-yellow-100 text-yellow-700",
  cerrada: "bg-gray-100 text-gray-500"
};

export default function Demandas() {
  const navigate = useNavigate();
  const [demandas, setDemandas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");

  useReloadOnRouteEnter(() => {
    setCargando(true);
    api.get("/demandas")
      .then(res => setDemandas(res.data.data))
      .catch(err => console.error("Error cargando demandas:", err))
      .finally(() => setCargando(false));
  });

  const filtradas = demandas.filter((d) =>
    !busqueda.trim() || textIncludesAny([d.nombre, d.poblacion, d.familia, d.cliente_nombre], busqueda)
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate("/dashboard")} className="text-gray-400 hover:text-gray-600">Dashboard</button>
          <div>
            <h1 className="font-bold text-gray-800 text-lg">Demandas</h1>
            <p className="text-xs text-gray-500">{demandas.length} demandas en total</p>
          </div>
        </div>
      </header>
      <main className="p-6">
        <div className="mb-6">
          <input value={busqueda} onChange={e => setBusqueda(e.target.value)} placeholder="Buscar por nombre, poblacion, familia o cliente..." className="w-full max-w-md px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-blue-500" />
        </div>
        {cargando ? (
          <div className="text-center py-20 text-gray-400">Cargando...</div>
        ) : filtradas.length === 0 ? (
          <div className="text-center py-20 text-gray-400">
            <p className="font-semibold text-gray-600">No hay demandas todavia</p>
          </div>
        ) : (
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase">Demanda</th>
                  <th className="text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase">Cliente</th>
                  <th className="text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase">Familia</th>
                  <th className="text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase">Poblacion</th>
                  <th className="text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase">Precio max</th>
                  <th className="text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase">Estado</th>
                </tr>
              </thead>
              <tbody>
                {filtradas.map((d, i) => (
                  <tr key={d.id} onClick={() => navigate("/demandas/" + d.id)} className={"cursor-pointer hover:bg-blue-50 transition-colors " + (i % 2 === 0 ? "bg-white" : "bg-gray-50")}>
                    <td className="px-4 py-3">
                      <p className="font-semibold text-gray-800 text-sm">{d.nombre}</p>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-500">{d.cliente_nombre} {d.cliente_apellido || ""}</td>
                    <td className="px-4 py-3">
                      <span className={"text-xs px-2 py-0.5 rounded-full font-medium " + (FAMILIA_COLOR[d.familia] || "bg-gray-100 text-gray-600")}>{d.familia}</span>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-500">{d.poblacion || "-"}</td>
                    <td className="px-4 py-3 text-sm text-gray-500">{d.precio_max ? Number(d.precio_max).toLocaleString("es-ES") + " EUR" : "-"}</td>
                    <td className="px-4 py-3">
                      <span className={"text-xs px-2 py-1 rounded-full font-semibold " + (ESTADO_COLOR[d.estado] || "")}>{d.estado}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  );
}